module.exports = __webpack_public_path__ + "static/sport/swiper-3.af94c15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper/swiper-3.jpg
// module id = bWU6
// module chunks = 0